<script lang="ts">
  import '$src/app.css'

  import { page } from '$app/stores'
  import NavBar from '$components/common/NavBar.svelte'
  import NavFooter from '$components/common/NavFooter.svelte'
</script>

<NavBar />

<main class={$page.url.pathname === '/' ? '' : 'pt-16'}>
  <slot />
</main>

<NavFooter />
